import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import { drawHeader } from "../../../../component/WGRHeader";
import { drawFooter } from "../../../../component/WGRFooter";
import { drawShopTable } from "./pohPDFTable";
import { handlePdf, PDF_ACTION } from "../../../../../../utils/pdfHelper"
import { drawGrandTotal } from "./pohdrawGrandTotalpdf";
export default function generateWGRPDF(
  reportType,
  title,
  grandTotal,
  rows,
  summary,
  month,
  year
) {
  const doc = new jsPDF({
    orientation: "l",
    unit: "mm",
    format: "a4",
  });

  const grouped = groupByShop(rows);


  //console.log("Grouped Data:", grouped);
  let firstPage = true;



  drawHeader(doc, month, year, title);

  Object.keys(grouped)
    .sort((a, b) => Number(a) - Number(b))
    .forEach((shop) => {
      drawShopTable(doc, shop, grouped[shop].rows, grouped[shop].total);
    });



drawGrandTotal(doc, grandTotal);
  

  drawFooter(doc, month, year, title);

 handlePdf(doc, PDF_ACTION.VIEW);
}


function groupByShop(rows) {
  return rows.reduce((groups, row) => {
    const shop = row.rail ?? "Unknown";

    if (!groups[shop]) {
      groups[shop] = {
        rows: [],
        total: {
          noofcoaches: 0,
          Mech_LabourCost: 0,
          Mech_MaterialCost: 0,
          Elec_LabourCost: 0,
          Elec_MaterialCost: 0,
          totalcost: 0,
        },
      };
    }

    groups[shop].rows.push(row);

    groups[shop].total.noofcoaches += Number(row.noofcoaches || 0);
    groups[shop].total.Mech_LabourCost += Number(row.Mech_LabourCost || 0);
    groups[shop].total.Mech_MaterialCost += Number(row.Mech_MaterialCost || 0);
    groups[shop].total.Elec_LabourCost += Number(row.Elec_LabourCost || 0);
    groups[shop].total.Elec_MaterialCost += Number(row.Elec_MaterialCost || 0);
    groups[shop].total.totalcost += Number(row.totalcost || 0);
    

    return groups;
  }, {});
}